import {
  FormControl,
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
} from "@mui/material";
import { IconTypes } from "../../components/icons.types";
import { copyTextToClipboard } from "../../ui/ui-util";

type ShareLinkFieldProps = {
  id: string;
  label: string;
  path: string;
  openIcon?: React.ReactNode;
  openTitle?: string;
  helperText?: string;
  disabled?: boolean;
  sx?: SxProps;
};

export const ShareLinkField = ({
  id,
  path,
  label,
  openIcon,
  openTitle,
  helperText,
  disabled,
  sx,
}: ShareLinkFieldProps) => {
  return (
    <FormControl fullWidth sx={sx}>
      <TextField
        id={id}
        label={label}
        value={path}
        helperText={helperText}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                title="Copy the link to clipboard"
                onClick={() => copyTextToClipboard(path, id)}
              >
                <IconTypes.CopyAction />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                title={openTitle || "Open this link in the new tab"}
                href={path}
                target="_blank"
              >
                {openIcon ?? <IconTypes.OpenInNew />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};
